export const REDIRECT_RULES = [
    {
      from: 'weightloss-experience',
      field: 'weightlossExperience',
      value: 'I’ve never tried losing weight before',
      to: 'success-visualization',
    },
    {
      from: 'previous-attempt',
      field: 'previousAttempt',
      value: 'No',
      to: 'success-visualization',
    },
    {
      from: 'calorie-tracking-before',
      field: 'calorieTrackingBefore',
      value: 'Yes',
      to: 'calorie-tracking-transition',
    },
    {
      from: 'calorie-tracking-before',
      field: 'calorieTrackingBefore',
      value: 'No',
      to: 'calorie-education',
    },
    {
      from: 'calorie-tracking-transition',
      field: 'calorieTrackingBefore',
      value: 'Yes',
      to: 'calorie-difficulty',
    },
    {
      from: 'calorie-difficulty',
      field: 'calorieDifficulty',
      value: 'Yes',
      to: 'no-starving-transition',
    },
    {
      from: 'calorie-difficulty',
      field: 'calorieDifficulty',
      value: 'No',
      to: 'success-path-transition',
    },
    {
      from: 'calorie-education',
      field: 'calorieEducation',
      value: 'Yes',
      to: 'simple-idea-transition',
    },
    {
      from: 'simple-idea-transition',
      field: 'calorieEducation',
      value: 'Yes',
      to: 'stay-on-track',
    },
    {
      from: 'calorie-education',
      field: 'calorieEducation',
      value: 'No',
      to: 'stay-on-track',
    },
    {
      from: 'start-emotions',
      field: 'startEmotions',
      value: 'Motivated',
      to: 'excellent-news-transition',
    },
    {
      from: 'excellent-news-transition',
      field: 'startEmotions',
      value: 'Motivated',
      to: 'goal-motivation',
    },
    {
      from: 'start-emotions',
      field: 'startEmotions',
      value: 'Confident',
      to: 'excellent-news-transition',
    },
    {
      from: 'excellent-news-transition',
      field: 'startEmotions',
      value: 'Confident',
      to: 'goal-motivation',
    },
    {
      from: 'start-emotions',
      field: 'startEmotions',
      value: 'Nervous',
      to: 'we-help-transition',
    },
    {
      from: 'we-help-transition',
      field: 'startEmotions',
      value: 'Nervous',
      to: 'goal-motivation',
    },
    {
      from: 'start-emotions',
      field: 'startEmotions',
      value: 'Disappointed',
      to: 'we-help-transition',
    },
    {
      from: 'we-help-transition',
      field: 'startEmotions',
      value: 'Disappointed',
      to: 'goal-motivation',
    },
    {
      from: 'start-emotions',
      field: 'startEmotions',
      value: 'Unmotivated',
      to: 'we-help-transition',
    },
    {
      from: 'we-help-transition',
      field: 'startEmotions',
      value: 'Unmotivated',
      to: 'goal-motivation',
    },
    {
      from: 'start-emotions',
      field: 'startEmotions',
      value: 'Not sure',
      to: 'normal-transition',
    },
    {
      from: 'normal-transition',
      field: 'startEmotions',
      value: 'Not sure',
      to: 'goal-motivation',
    },
    {
      from: 'children',
      field: 'children',
      value: 'No, I don’t have kids',
      to: 'work-schedule',
    },
    {
      from: 'social-eating',
      field: 'socialEating',
      value: 'They eat healthy regularly',
      to: 'stay-motivated',
    },
    {
      from: 'weekend-more',
      field: 'weekendMore',
      value: 'No',
      to: 'personal-plan-4',
    },
  ];
  